import React, { Component } from 'react'
import './reservation.css'

export default class Reservation extends Component {

    constructor( props ) {

        super( props )
        this.state = {
        }
    }

    /**
     * Renderiza o componente de descrição do curso vendido
     */

    Title() {
        return(
            <div id="c-reservation-title">
                <header className="reservation-title">
                    <p className="reservation-area">
                        {this.props.area}
                    </p>
                    <p className="reservation-description">
                        Descrição: {this.props.description}
                    </p>
                </header>
            </div>
        );
    }

    /**
     * Renderiza o componente de requisitos do interessado
     */

    Requirements() {
        return(
            <div id="c-reservation-requirements">
                <section className="reservation-requirements">
                    <p className="requirements-pre">
                        <i className="i-disponibility-black log"></i>
                        Disponibilidade:{this.props.disponibility}
                    </p>
                    <p className="requirements-modality">
                    <i className="i-modality-black log"></i>
                        Modalidade: {this.props.modality}
                    </p>
                    <p className="requirements-duration">
                        <i className="i-duration-black log"></i>
                        Duração: {this.props.duration}
                    </p>
                </section>
            </div>
        );
    }



    /**
     * ATENÇÃO: Inserir agora a verificação de qual página deve ser renderizada!
     * ---
     * Renderiza o componente de data/botão
     */

    DateAndButton( el, index ) {
                
            return(
                
                    <section className="date-button-wrapper" key={index}>
                        <label className="date-reservation">
                            <p className="reservation-date-p">
                                Data: {el[0]}
                            </p>
                            <p className="reservation-date-p">
                                {/* <input type="date" readOnly="true" /> */}
                            </p>
                        </label>
                        <div className="reservation-button">
                            <a className="reservation-button-a" href={el[1]} rel="" target="_blank">
                                Reservar
                            </a>
                        </div>
                    </section>
                
            )
    }

    /**
     * Renderiza o componente principal.
     */

    render() {
        return(

            <section id="c-reservation">
                {/* Title */}
                {this.Title()}
                {/* Requisitos */}
                {this.Requirements()}
                {/* DateAndButton */}
                <div id="c-reservation-date">
                    {this.props.schedule.map((el, index) => this.DateAndButton(el,index))}
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/workshop/reservation.js